export default __webpack_public_path__ + "static/media/icon-pencil.838f4bf9.svg";